<template>
     <li>
                <article>
                  <p class="margin-notes">
                    <time class="highlight-strip">
                      <div v-if="e.eventType" v-html="formatEventType(e.eventType)"> </div>
                 
                 <!-- {{e.collection}} -->
                 
                      <span class="date" > {{ compareDates(e.startDate, e.endDate) }} </span>

                    <!-- REMOVE~~~~~~~~~~~~~~~~~~~~~~~~~ -->
                      <!-- <span class="date" v-if="e.startDate && !e.endDate "> {{ formatDate(e.startDate, 'D MMM YYYY') }} </span>
                     
                      <span class="date" v-else-if="e.startDate == e.endDate || formatDate(e.startDate, 'YYYY') > formatDate(e.endDate, 'YYYY')"> {{ formatDate(e.startDate, 'D MMM YYYY') }} </span>

                      <span class="date" v-else-if="e.startDate && e.endDate "> {{formatDate(e.startDate, 'D MMM')}} - {{ formatDate(e.endDate, 'D MMM YYYY') }} </span> -->
  
                      <span class="time" v-if="e.startTime">from {{e.startTime.replace(' ','')}} 
                        <!-- <span v-if="e.endTime">to {{e.endTime.replace(' ','')}}</span> -->
                        </span>
                    </time>
                  </p>
  
                  <div class="summary formatting">
                    <h3>
                      <a
                        :href="wwwUrl(e.url)"
                        title="See event details"
                        >{{e.title}}</a
                      >
                    </h3>
  
                      <figure class="media inline" v-if="e.image">
                          <img :src="e.image" :title="e.title"
                            :data-copyright-show="e.imageShowCopyright"
                            :data-copyright-url="e.imageCopyrightUrl"
                            :data-copyright-text="e.imageCopyrightText"
                          >
                     </figure>
                    <p v-if="e.blurb && e.blurb != 'null'">{{e.blurb}}</p>
                    <p v-else>{{e.description}}</p>

                    <p class="meta venue" v-if="e.location">
                      <span class="icon-pin"></span>{{e.location}}</p>
                    <div class="meta venue" v-if="e.eventAudience" v-html="audienceTags(e.eventAudience)">
                    </div>
                  </div>

                  <p class="event-tag" v-if="e.collection == 'squiz' && e.eventOwner != siteName && e.eventOwner != 'Events' ">
                   This event comes from
                    <a :href="wwwUrl(e.eventOwnerEventsLink)">{{e.eventOwner}}</a>
                  </p>

                  <p class="event-tag" v-else-if="e.eventOwner == 'Events' ">
                   This event comes from the University's main 
                    <a href="https://www.wgtn.ac.nz/events">{{e.eventOwner.toLowerCase()}} </a> page.
                  </p>
  
                </article>
              </li>
</template>

<script>
var dayjs = require("dayjs");

export default {
  name: "Event",
  props: ["e", "index"],
  methods: {
    formatDate(date) {
      let d = dayjs(date).format("D MMMM YYYY");
      return `${d}`;
    },
    wwwUrl(url) {
      return url.replace("cms", "www");
    },
    formatEventType(type) {
      if (type.includes(";")) {
        let types = type
          .split(";")
          .map((t) => `<span class="type-tag">${t.trim()}</span>`)
          .join("");
        return types;
      } else {
        return `<span>${type}</span>`;
      }
    },
    audienceTags(e) {
    let tagHtml = e.split(';').map( tag => `<span class="tag tag-grey mr1">${tag}</span>` ).join('');
      return tagHtml;
    },
    compareDates(sD, eD) {
      if (sD && !eD) {
        return dayjs(sD).format("D MMM YYYY");
      } else if (sD >= (eD && dayjs(eD).isValid())) {
        return dayjs(sD).format("D MMM YYYY");
      } else {
        return `${dayjs(sD).format("D MMM")} - ${dayjs(eD).format(
          "D MMM YYYY"
        )}`;
      }
    },
  },
};
</script>

<style lang="scss">
.event {
  margin-bottom: 1.5rem !important;

  &:not(:last-child) {
    margin-bottom: 1.5rem;
    padding-bottom: 1.5rem;
    border-bottom: 0.0625rem solid #ddd;
  }
}

.margin-notes {
  .tag {
    margin-top: 0.5rem;
    font-size: 0.8rem;
    margin-left: 1.125rem;
  }
}
</style>